import { QcDialog } from '@tencent/qcvue2';

const dialog = {
  alert(
    {
      message,
      title,
      width = 420,
      icon = 'error',
      confirmText,
    } = {},
    callback,
  ) {
    const { lang } = window;
    QcDialog.alert({
      title: title || lang.t('core.default_title'),
      message: message || lang.t('core.default_msg'),
      width,
      icon,
      confirmText,
    }).then(() => {
      if (callback) {
        callback();
      }
    });
  },
  confirm(
    {
      message,
      title,
      width = 420,
      icon = 'error',
      confirmText,
      cancelText,
      content,
    } = {},
    callback,
  ) {
    QcDialog.confirm({
      title,
      message,
      width,
      icon,
      confirmText,
      cancelText,
      content,
      closeTriggers: [],
    }).then(confirm => {
      callback(confirm);
    });
  },
};

export default dialog;
